import React, { useState } from "react";
import Handler from "../../../Helpers/Components/Handler"
import { useDispatch, useSelector } from "react-redux";
import { PhoneInput } from "react-international-phone";
import { setBooking, setPhone, setPhone2, setPhone3, setStep } from "../../../Reducer/bookingSlice";
import { toast } from "react-toastify";
import NextPrev from "../../../Helpers/Components/NextPrev"
import Modal from "../../../Helpers/Components/Modal";

const Customer = (props) => {
    const [loading, setLoading] = useState(false)
    const [expiryConfirm, setExpiryConfirm] = useState({ open: false, message: "", data: null })
    const booking = useSelector(state => state?.booking?.booking)
    const dispatch = useDispatch()
    const validPhoneNumber = new RegExp('^[6-9]{1}[0-9]{9}');

    const submitFirstUpdate = async (data) => {
        setLoading(true)
        const response = await Handler({ url: `/booking/delivery/first/update/${props?.bookingId}`, method: 'patch', data })
        if (response?.success) {
            setExpiryConfirm({ open: false, message: "", data: null })
            dispatch(setStep(1))
        } else if (response?.message?.includes("Confirm to proceed")) {
            setExpiryConfirm({ open: true, message: response?.message, data })
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    const confirmExpiredProceed = () => {
        if (expiryConfirm?.data) submitFirstUpdate({ ...expiryConfirm.data, confirmExpiry: true })
    }

    const handleChange = (e) => {
        dispatch(setBooking({ [e.target.name]: e.target.value }))
    }
    const handleNext = async () => {
        const isNRI = booking?.customer?.custType === "nri";
        const hasDuplicatePhone = booking?.phone1?.phone === booking?.phone2?.phone || (!isNRI && (booking?.phone1?.phone === booking?.phone3?.phone || booking?.phone2?.phone === booking?.phone3?.phone));
        if ((!booking?.formNo)) {
            toast.error("Form No is required");
        } else if (!booking?.phone2?.phone || ((booking?.phone2?.code === "+91" || booking?.phone2?.code === "91") && !validPhoneNumber?.test(booking?.phone2?.phone))) {
            toast.error("Alt no 1 is required");
        } else if ((booking?.customer?.custType === "nri") ? false : (!booking?.phone3?.phone || ((booking?.phone3?.code === "+91" || booking?.phone3?.code === "91") && !validPhoneNumber?.test(booking?.phone3?.phone)))) {
            toast.error("Alt no 2 is required");
        } else if (hasDuplicatePhone) {
            toast.error("Number can't be same");
        } else {
            setLoading(true)
            const data = {
                formNo: booking?.formNo,
                customerId: booking?.customerId,
                phone: [
                    booking?.phone,
                    booking?.phone2,
                    ...(booking?.phone3?.phone ? [{ ...booking?.phone3 }] : [])
                ]
            };
            await submitFirstUpdate(data)
        }
    }
    const setSteps = () => {
        dispatch(setStep(1))
    }
    return (
        <React.Fragment>
            <Modal header={"Document Expired"} centered={true} onShow={expiryConfirm?.open} toggle={() => setExpiryConfirm({ open: false, message: "", data: null })} overlayToggle={() => setExpiryConfirm({ open: false, message: "", data: null })}>
                <div className="p-3 text-center">
                    <p className="mb-4">{expiryConfirm?.message}</p>
                    <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-theme" disabled={loading} onClick={confirmExpiredProceed}>Yes, Proceed Anyway</button>
                        <button className="btn btn-danger" disabled={loading} onClick={() => setExpiryConfirm({ open: false, message: "", data: null })}>Cancel</button>
                    </div>
                </div>
            </Modal>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="formNo" className="form-label"> Form No </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} name="formNo" id="formNo" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.formNo || ""} />
                    </div>
                </div>
            </div>
            <div className="row my-3">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="firstName" className="form-label">Customer Name </label>
                        <input readOnly name="firstName" id="firstName" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(booking?.firstName || "") + " " + (booking?.lastName || "")} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div>Driving License: {booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")[0]?.id : "-" : "-"}</div>
                    <div> Driving License Date: {booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")[0]?.detail?.validTo : "-" : "-"} </div>
                    <div> Mobile Number: {booking?.customer?.phone?.length ? booking?.customer?.phone?.filter(element => element?.priority === 1)?.length ? ((booking?.customer?.phone?.filter(element => element?.priority === 1)[0]?.code || "") + "-" + (booking?.customer?.phone?.filter(element => element?.priority === 1)[0]?.phone || "")) : "-" : "-"} </div>
                    <div> Alternate Number : {booking?.customer?.phone?.length ? booking?.customer?.phone?.filter(element => element?.priority === 2)?.length ? ((booking?.customer?.phone?.filter(element => element?.priority === 2)[0]?.code || "") + "-" + (booking?.customer?.phone?.filter(element => element?.priority === 2)[0]?.phone || "")) : "-" : "-"} </div>
                    <div> Alternate Number 2 : {booking?.customer?.phone?.length ? booking?.customer?.phone?.filter(element => element?.priority === 3)?.length ? ((booking?.customer?.phone?.filter(element => element?.priority === 3)[0]?.code || "") + "-" + (booking?.customer?.phone?.filter(element => element?.priority === 3)[0]?.phone || "")) : "-" : "-"} </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="phone" className="form-label"> Alt 1 </label>
                        <PhoneInput
                            defaultCountry="in"
                            disabled={loading}
                            onPaste={(e) => {
                                e.preventDefault();
                                let pasteData = e.clipboardData.getData('Text');
                                pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
                                dispatch(setPhone2({ phone: pasteData, code: e[0] }))
                            }}
                            value={booking?.phone2?.phone ? booking?.phone2?.code + booking?.phone2?.phone : ""}
                            onChange={(phone1, metadata) => {
                                const code = `+${metadata.country.dialCode}`;
                                const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                dispatch(setPhone2({ phone: phone || "", code: code || "+91" }))
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="phone" className="form-label"> Alt 2 </label>
                        {/* <PhoneInput
                            defaultCountry="in"
                            disabled={loading}
                            value={booking?.phone3?.phone ? booking?.phone3?.code + booking?.phone3?.phone : ""}
                            onChange={(phone1, metadata) => {
                                let e = metadata?.inputValue?.split(" ")
                                dispatch(setPhone3({ phone: e[1] ? e[1]?.replace("-", "") : "" }))
                            }}
                        /> */}
                        <PhoneInput
                            defaultCountry="in"
                            disabled={loading}
                            value={booking?.phone3?.phone ? booking?.phone3?.code + booking?.phone3?.phone : ""}
                            onChange={(phone1, metadata) => {
                                const code = `+${metadata.country.dialCode}`;
                                const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                dispatch(setPhone3({ phone: phone || "", code: code || "+91" }))
                            }}

                            onPaste={(e) => {
                                e.preventDefault();
                                let pasteData = e.clipboardData.getData('Text');
                                pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
                                dispatch(setPhone3({ phone: pasteData, code: e[0] }))
                            }}
                        />
                    </div>
                </div>
            </div>
            <NextPrev step={0} setStep={setSteps} last={3} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Customer;